import { type CommonData, Country } from "../../../../types/common";
import { NormalInfoWrapper } from "../../../tasks/styles";
import { RowsWrapper } from "../../styles";

interface OfferDetailsProps {
  data: CommonData;
  isLoan?: boolean;
}

interface Detail {
  label: string;
  value: any;
}
function getDebtToBeReedemed(data: CommonData) {
  if (data?.offer?.debtsToBeRedeemed) {
    return data.offer.debtsToBeRedeemed;
  }
  return data?.agentApiApplication?.application?.refinanceAmount;
}

// FI states a monthly gross income (FI_Internal.StatedGrossIncome) rather than
// an annual one; the label reflects the period.
function getFiStatedGrossIncome(data: CommonData): string | undefined {
  const stated =
    data?.integrations?.statistica?.FI_Internal?.variables?.StatedGrossIncome;
  if (stated === null || stated === undefined || stated === "") {
    return undefined;
  }
  return `${stated}`;
}

function getIndexOfLastRow(details: Detail[]) {
  let lastValidRow = -1;
  let secondLastValidRow = -1;
  let validCount = 0;

  for (let i = 0; i < details.length; i++) {
    if (details[i].value != null) {
      secondLastValidRow = lastValidRow;
      lastValidRow = i;
      validCount++;
    }
  }

  return validCount % 2 === 0
    ? [secondLastValidRow, lastValidRow]
    : [lastValidRow];
}

export const FinancialRow = ({ data, isLoan = true }: OfferDetailsProps) => {
  // Finland sources the same financial fields from its own statistica endpoint.
  const external =
    data?.country === Country.FI
      ? data?.integrations?.statistica?.FI_External
      : data?.integrations?.statistica?.SE_External;
  const totUnsecuredDebtBal = external?.variables?.totUnsecuredDebtBal;
  const debtRatio = external?.variables?.debtRatio;
  const DebtToBeRedeemed = getDebtToBeReedemed(data);
  const ProbabilityOfDefaul = external?.variables?.ProbabilityOfDefault;
  const OwnsDwelling = external?.variables?.NDI;
  const incomeLastYear =
    data?.country === Country.FI
      ? getFiStatedGrossIncome(data)
      : external?.variables?.annualStatedGrossIncome;

  const statedGrossIncomeLabel =
    data?.country === Country.FI
      ? "Stated gross income monthly"
      : "Stated gross income annual";

  const financialDetails = [
    { label: statedGrossIncomeLabel, value: incomeLastYear },
    { label: "Total debt ratio", value: debtRatio },
    { label: "Unsecured debt ratio", value: totUnsecuredDebtBal },
    { label: "PD", value: ProbabilityOfDefaul },
    { label: "Affordability", value: OwnsDwelling }
  ];

  if (isLoan) {
    financialDetails.push({
      label: "Debt to be redeemed",
      value: DebtToBeRedeemed
    });
    financialDetails;
  }

  const lastIndexes = getIndexOfLastRow(financialDetails);

  const isEmpty = financialDetails.every(
    (detail) => detail.value === null || detail.value === undefined
  );
  if (isEmpty) {
    return null;
  }
  return (
    <RowsWrapper className="Financial information">
      <NormalInfoWrapper $header>Financial Details</NormalInfoWrapper>
      {financialDetails.map((detail, index) => {
        if (detail.value === null || detail.value === undefined) {
          return;
        }
        return (
          <NormalInfoWrapper
            key={`offer - ${detail.label}`}
            $isLast={lastIndexes.includes(index)}
          >
            <div>{detail.label}</div>
            <div>{detail.value}</div>
          </NormalInfoWrapper>
        );
      })}
    </RowsWrapper>
  );
};
